/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React from 'react';
import { shape, string } from 'prop-types';
import { compose } from 'recompose';
import { withRouter } from 'react-router';
import { connect } from 'react-redux';
import { getBrand } from '../../../../state/ducks/Member/ducks/Common/Common-Selectors';
import { trackModule } from '../../../helpers/tracking/common/commonTrackingHelpers';
import Graphql404ErrorContainer from '../Graphql404Error/Graphql404ErrorContainer';

export const ErrorBrowsingContainer = ({
    brand,
}) => {
    const page = {
        contentType: 'template_error_page',
    };
    return <Graphql404ErrorContainer brand={brand} page={page} />;
};

ErrorBrowsingContainer.propTypes = {
    brand: shape({
        'domain-name': string.isRequired,
    }).isRequired,
};

const mapStateToProps = (state) => ({
    brand: getBrand(state),
});

const enhance = compose(
    trackModule('ErrorBrowsingContainer'),
    withRouter,
    connect(mapStateToProps, null),
);

export default enhance(ErrorBrowsingContainer);
